import {
  actionGroups,
  eventActions,
  eventCategories,
  eventContexts,
  eventLabels,
  events,
  paymentMethods,
} from './constants'
import {
  PaymentContextParams,
  buildPaymentContext,
  defaultAmountSource,
  mapPaymentMethod,
  sendInteractionGtm,
  sendPageviewGtm,
} from './helpers'
import { sendGtmEvent } from './sendGtmEvent'
import { AmountSource, FunnelContent } from './types'

type ProductParams = Pick<PaymentContextParams, 'productName' | 'entry'>

type PayParams = ProductParams & {
  amount: string
  requestId: string
  transactionId: string
  paymentMethod: string
  amountSource?: AmountSource
}

type LoginPayParams = ProductParams & {
  amount: string
  amountSource?: AmountSource
}

type QrParams = ProductParams & {
  amount: string
  requestId: string
  transactionId: string
  amountSource?: AmountSource
}

type ResultParams = PayParams & {
  reason?: string
}

// Показ страницы тсп
export const tspPageShowGtm = (content: FunnelContent, params: ProductParams) =>
  sendPageviewGtm({
    eventLabel: eventLabels.rekvizity,
    ...buildPaymentContext({ content, ...params }),
  })

// Выбор номинала — только игры и сервисы
export const paymentTarifClickGtm = (content: FunnelContent, params: ProductParams & { denomination: string }) =>
  sendInteractionGtm({
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.tarif,
    ...buildPaymentContext({ content, ...params }),
  })

// Логин / ID игрока / почта
export const paymentLoginMailAddGtm = (content: FunnelContent, params: ProductParams) =>
  sendInteractionGtm({
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.loginMail,
    ...buildPaymentContext({ content, ...params }),
  })

// Промокод
export const paymentPromocodeAddGtm = (content: FunnelContent, params: ProductParams) =>
  sendInteractionGtm({
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.promokod,
    ...buildPaymentContext({ content, ...params }),
  })

// Клик на Оплатить
export const paymentPayClickGtm = (content: FunnelContent, params: PayParams) =>
  sendInteractionGtm({
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.kupit,
    ...buildPaymentContext({
      content,
      ...params,
      amountSource: defaultAmountSource(params.amountSource),
    }),
  })

// Клик на Войти и оплатить
export const paymentLoginPayClickGtm = (content: FunnelContent, params: LoginPayParams) =>
  sendInteractionGtm({
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.voitiOplatitit,
    ...buildPaymentContext({
      content,
      productName: params.productName,
      entry: params.entry,
      amount: params.amount,
      amountSource: defaultAmountSource(params.amountSource),
      paymentMethod: paymentMethods.mtsAccount,
    }),
  })

// Показ QR СБП
export const paymentQrShowGtm = (content: FunnelContent, params: QrParams) =>
  sendGtmEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovayaStranica,
    eventAction: eventActions.popupShow,
    eventLabel: eventLabels.oplataQr,
    actionGroup: actionGroups.nonInteractions,
    ...buildPaymentContext({
      content,
      productName: params.productName,
      entry: params.entry,
      amount: params.amount,
      requestId: params.requestId,
      transactionId: params.transactionId,
      amountSource: defaultAmountSource(params.amountSource),
      paymentMethod: paymentMethods.sbp,
    }),
  })

const resultEventContext = (paymentMethod: string) =>
  mapPaymentMethod(paymentMethod) === paymentMethods.sbp ? eventContexts.sbp : eventContexts.schetMts

const sendPaymentResultGtm = (
  params: ResultParams,
  fields: { eventAction: string; eventLabel: string; eventContext?: string }
) =>
  sendGtmEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovayaStranica,
    actionGroup: actionGroups.nonInteractions,
    ...buildPaymentContext({
      ...params,
      amountSource: defaultAmountSource(params.amountSource),
      errorName: params.reason,
    }),
    ...fields,
  })

// Платеж выполнен
export const paymentSuccessGtm = (params: PayParams) =>
  sendPaymentResultGtm(params, {
    eventAction: eventActions.formConfirmed,
    eventLabel: eventLabels.platezhOtpravlen,
    eventContext: resultEventContext(params.paymentMethod),
  })

// Платеж в обработке
export const paymentProcessingGtm = (params: PayParams) =>
  sendPaymentResultGtm(params, {
    eventAction: eventActions.formConfirmed,
    eventLabel: eventLabels.platezhVObrabotke,
    eventContext: resultEventContext(params.paymentMethod),
  })

// Платеж не отправлен
export const paymentFailGtm = (params: ResultParams) =>
  sendPaymentResultGtm(params, {
    eventAction: eventActions.formRejected,
    eventLabel: eventLabels.platezhNeOtpravlen,
  })
